/* eslint-disable ts/method-signature-style */
/* eslint-disable no-extend-native */

export {}

declare global {
    interface Date {
        toUtcMinus4String(): string
        addDays(days: number): Date
        addHours(hours: number): Date
    }
}

Date.prototype.toUtcMinus4String = function (): string {
    const offset = -4 * 60 * 60 * 1000
    const myDate = new Date(this.getTime() + offset)
    const forDate = new Date(myDate.getUTCFullYear(), myDate.getUTCMonth(), myDate.getUTCDate())
    return `${forDate.toLocaleDateString()} ${myDate.getUTCHours().toString().padStart(2, '0')}:${myDate
        .getMinutes()
        .toString()
        .padStart(2, '0')}:${myDate.getUTCSeconds().toString().padStart(2, '0')}`
}

Date.prototype.addDays = function (days: number): Date {
    const date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
}

Date.prototype.addHours = function (hours: number): Date {
    const date = new Date(this.valueOf())
    date.setHours(date.getHours() + hours)
    return date
}
